import React from 'react';
import PortfolioContainer from '../../../../components/Portfolio/PortfolioContainer';
import LenderUgroService from '../../../../services/lender';
import { Context } from '../../../../config/store';
import { Link, useParams, useNavigate } from 'react-router-dom';
import message from '../../../../constant/message';
import { toast } from 'react-toastify';
import {
	objectsForEach,
	getAddInfoArray,
} from '../../../../common/objectToArray';
import Section from '../../../../components/AddLead/Section';
const AdditionalInformation = ({
	getLeadDetail,
	selectedLender,
	cl_lead_lender_status,
	isAdditionalInfoRequired,
	showAdditionalInfo,
}) => {
	const [leadId, setLeadId] = React.useState('');
	const [infoId, setInfoId] = React.useState('');
	const [leadData, setLeadData] = React.useState({});

	const [addInfoConfig, setAddInfoConfig] = React.useState({});
	const [addInfoConfigCopy, setAddInfoConfigCopy] = React.useState({});
	const [body, setBody] = React.useState({});
	const { state } = React.useContext(Context);
	const [loading, setLoading] = React.useState(false);
	const [errors, setErrors] = React.useState({});
	const [getError, setGetError] = React.useState(false);
	const [getLoading, setGetLoading] = React.useState(false);
	const [mastersData, setMastersData] = React.useState({});
	const params = useParams();
	const navigate = useNavigate();

	React.useEffect(() => {
		setLeadId(params.id);
		getLeadAdditionalInfo(params.id);
	}, [selectedLender]);
	const saveAdditionalInformation = async (e) => {
		try {
			e.preventDefault();
			setLoading(true);
			if (!isAdditionalInfoRequired) {
				return navigate('/portfolio/view/' + leadId + '/documents');
			}
			const requestBody = { ...leadData, ...body };
			const requestBody2 = keepActualData(requestBody, addInfoConfig);
			// check coapplicant age for kvb lender
			if(requestBody2?.coapplicant_details?.[0]?.CoapplicantAge){
				let is_valid = true;
				let age_bt_80_85 = (requestBody2?.coapplicant_details).filter(({CoapplicantAge}) => CoapplicantAge == 'Yes');
				if(age_bt_80_85.length && !age_bt_80_85.some(({LegalHeir, NOCDoc}) => LegalHeir == 'Yes' && NOCDoc == 'Yes')){
					is_valid = false;
				}
				if(!is_valid){
					toast.error('Please fill the required data and Atleast one Co-Applicant with Legal Heir and NOC Document.');
					setLoading(false);
					return false;
				}
			}
			// check coapplicant age for kvb lender
			/** Validate only ABCL **/
			const validateSpecLenderIds = [22];
			const trnchLenderId = Number(selectedLender);
			if (validateSpecLenderIds.includes(trnchLenderId)) {
				const trancheCount = Number(requestBody2?.loan_details?.NumberOfTranche ?? 0);
				let trnchResponse = await LenderUgroService.getAdditionalInfoTranchData({
					type: state.userType,
					add_info_trnch_id: null,
					leadId: leadId,
					cl_lender_id: selectedLender
				});
				const addTrancheCount = Number(trnchResponse?.data?.data?.addInfoTrnch?.res_json?.length ?? 0);
				//console.log(trancheCount, addTrancheCount);
				if (trancheCount !== addTrancheCount) {
					toast.error(`Your Number of Tranche ${trancheCount} is not equal to count of additional tranche details ${addTrancheCount}`);
					setLoading(false);
					return;
				}
			}
			/** Validate only ABCL end **/
			
			let response = await LenderUgroService.addAdditionalInformation({
				type: state.userType,
				leadId: leadId,
				infoId: infoId,
				lenderId: selectedLender,
				requestBody: requestBody2,
			});

			if (response?.data?.status?.code === 1) {
				const success = response?.data?.messages?.success;

				toast.success(
					success?.form?.[0] || success?.others?.[0] || message.SAVED_SUCCESS
				);
				await getLeadDetail();
				navigate('/portfolio/view/' + leadId + '/documents');
			}
			setLoading(false);
		} catch (err) {
			let error = err?.response?.data?.messages?.error;
			toast.error(error?.form?.[0] || error?.others?.[0] || message.ERROR_FORM);
			setErrors(err?.response?.data?.data.err_data);
			setLoading(false);
		}
	};

	const getLeadAdditionalInfo = async (leadId) => {
		setGetError(false);
		setGetLoading(true);
		try {
			const response = await LenderUgroService.getAdditionalInformation({
				type: state.userType,
				params: { cl_lead_id: leadId, lender_id: selectedLender },
			});
			setInfoId(response?.data?.data?.addInfo?.add_info_id);
			const responseAddInfoData = response?.data?.data?.addInfo?.res_json;
			const landerConfigData = response?.data?.data?.landerConfig;

			/** Add block at 10-06-2026 **/
			const loan_details = {
				NumberOfTranche: landerConfigData?.loan_details?.NumberOfTranche?.rule?.value,
				TypeOfLoan: landerConfigData?.loan_details?.TypeOfLoan?.rule?.value,
				...(responseAddInfoData?.loan_details || {}),
			}
			/** Add block at 10-06-2026 end **/

			const collateral_details = (
				landerConfigData?.['collateral_details'] || []
			).map((collateral, index) => {
				return {
					CollatralId: collateral.CollatralId.rule.value,
					PropertyAddress: collateral?.PropertyAddress?.rule?.value,
					ModelDescription: collateral?.ModelDescription?.rule?.value,
					City: collateral?.City?.rule?.value,
					PinCode: collateral?.PinCode?.rule?.value,
					OccupancyStatus: collateral?.OccupancyStatus?.rule?.value,
					...(responseAddInfoData?.collateral_details?.[index] || {}),
				};
			});

			const coapplicant_details = (
				landerConfigData?.['coapplicant_details'] || []
			).map((coapplicant, index) => {
				return {
					CoapplicantId: coapplicant?.CoapplicantId?.rule?.value,
					CoapplicantName: coapplicant?.CoapplicantName?.rule?.value,
					CoapplicantPan: coapplicant?.CoapplicantPan?.rule?.value,
					CoapplicantCkyc: coapplicant?.CoapplicantCkyc?.rule?.value,
					CoapplicantAge: coapplicant?.CoapplicantAge?.rule?.value,
					CoapplicantType: coapplicant?.CoapplicantType?.rule?.value,
					...(responseAddInfoData?.coapplicant_details?.[index] || {}),
				};
			});

			const more_info = (
				landerConfigData?.['more_info'] || []
			).map((more, index) => {
				return {
					COLLATERAL_ID: more?.COLLATERAL_ID?.rule?.value,
					...(responseAddInfoData?.more_info?.[index] || {}),
				};
			});
			const busniess_details = {
				UdyamAadharNo: landerConfigData?.business_additional_info?.UdyamAadharNo?.rule?.value,
				UdyamIssueDate: landerConfigData?.business_additional_info?.UdyamIssueDate?.rule?.value,
				UdyamNICCode: landerConfigData?.business_additional_info?.UdyamNICCode?.rule?.value,
				Industry: landerConfigData?.business_additional_info?.Industry?.rule?.value,
				...(responseAddInfoData?.business_additional_info || {}),
			}

			const financial_details = {
				AdjustedABB: landerConfigData?.financial_details?.AdjustedABB?.rule?.value,
				SumABB: landerConfigData?.financial_details?.SumABB?.rule?.value,
				...(responseAddInfoData?.financial_details || {}),
			}

			const applicant_details = {
				ApplicantCkyc: landerConfigData?.applicant_details?.ApplicantCkyc?.rule?.value,
				...(responseAddInfoData?.applicant_details || {}),
			}

			setBody(
				{
					...responseAddInfoData,
					business_additional_info: busniess_details,
					collateral_details: collateral_details,
					financial_details: financial_details,
					applicant_details: applicant_details,
					coapplicant_details: coapplicant_details,
					more_info: more_info,
					loan_details: loan_details,
				} || {}
			);
			setAddInfoConfig(response?.data?.data?.landerConfig || {});
			setAddInfoConfigCopy(response?.data?.data?.landerConfig || {});
			setMastersData(response?.data?.data?.masters || {});
			setGetLoading(false);
		} catch (err) {
			setGetError(true);
			setGetLoading(false);
		}
	};
	const checkHasPermission = (checkPermission) => {
		if (state.is_super_admin === 1) return true;
		const permission = state.permission.find(
			(permission) => permission === checkPermission
		);

		if (permission) return true;
		else return false;
	};

	const getOptionsData = (mst_key) => {
		let actualMasters = mastersData[mst_key] ?? [];
		let actualOptions = {};
		actualMasters.map(({id, name}) => {
			actualOptions[name] = id;
		});
		return actualOptions;
	};

	const getOptionsDataForSlave = (mst_key, val) => {
		let actualMasters2 = (mastersData?.[mst_key] || []).filter(data => data.id == val);
		let actualOptions2 = {};
		(actualMasters2?.[0]?.slave || []).map(({id, name}) => {
			actualOptions2[name] = id;
		});
		return actualOptions2;
	}

	const getOptionsDataForSlave2 = (mst_key, val, label_up_val) => {
        let actualMasters1 = (mastersData?.[mst_key] || []).filter(data => data.id == label_up_val);
        let actualMasters2 = (actualMasters1?.[0]?.slave || []).filter(data => data.id == val);
        let actualOptions2 = {};
        (actualMasters2?.[0]?.slave || []).map(({id, name}) => {
            actualOptions2[name] = id;
        });
        return actualOptions2;
    }

	React.useEffect(() => {
		changeAddInfoConfig(body)
	}, [body, addInfoConfigCopy, mastersData]);

	const changeAddInfoConfig = (new_body) => {
        let temp_config = JSON.parse(JSON.stringify(addInfoConfigCopy));
        let deleted_key_arr = [];
        Object.keys(temp_config).map(p_key => {
            Object.entries(temp_config[p_key]).map((c_key, i) => {
                if(!(/^\d/.test(c_key[0]))){
                    // for Single Type Block
                    if (!(c_key[0] == 'title' || c_key[0] == 'type')) {
                        let v = c_key[0];
                        let dependency_field = c_key[1]?.['dependency_field'];
                        let repulsion_input_value = new_body?.[p_key]?.[dependency_field] ?? '';
                        let repulsion_value = (c_key[1]?.['repulsion_value'] || []);
                        let on_change = temp_config[p_key][v]?.['on_change'] ?? '';
                        let label_up = temp_config[p_key][v]?.['label_up'] ?? '';
                        let masters = temp_config[p_key][v]?.['masters'] ?? '';
                        if(masters){
                            temp_config[p_key][v]['rule']['options'] = getOptionsData(masters);
                        }
                        if(on_change){
                            let current_selected_value = new_body?.[p_key]?.[v] ?? '';
                            let label_up_selected_value = new_body?.[p_key]?.[label_up] ?? '';
                            temp_config[p_key][on_change]['rule']['options'] = label_up ? getOptionsDataForSlave2(label_up, current_selected_value, label_up_selected_value) : getOptionsDataForSlave(masters, current_selected_value);
                        }
                        if (repulsion_value.includes(repulsion_input_value || '')) {
                            deleted_key_arr.push(v);
                            delete temp_config[p_key][v];
                        }
                    }
                }else{
                    // for Multiple Type Block
                    Object.entries(temp_config[p_key][i]).map((c_key) => {
                        if (!(c_key[0] == 'title' || c_key[0] == 'type')) {
                            let v = c_key[0];
                            let dependency_field = c_key[1]?.['dependency_field'];
                            let repulsion_input_value = new_body?.[p_key]?.[i]?.[dependency_field] ?? '';
                            let repulsion_value = (c_key[1]?.['repulsion_value'] || []);
                            let on_change = temp_config[p_key][i][v]?.['on_change'] ?? '';
                            let masters = temp_config[p_key][i][v]?.['masters'] ?? '';
                            if(masters){
                                temp_config[p_key][i][v]['rule']['options'] = getOptionsData(masters);
                            }
                            if(on_change){
                                let current_selected_value = new_body?.[p_key]?.[i]?.[v] ?? '';
                                temp_config[p_key][i][on_change]['rule']['options'] = getOptionsDataForSlave(masters, current_selected_value);
                            }
                            if (repulsion_value.includes(repulsion_input_value || '')) {
                                deleted_key_arr.push(v);
                                delete temp_config[p_key][i][v];
                            }
                        }
                    })
                }
            })
        })
        // setBody(new_body);
        setAddInfoConfig(temp_config);
    }

	const keepActualData = (req_data, config) => {
		let data = JSON.parse(JSON.stringify(req_data));
		Object.keys(data).map(k => {
			let conf = config[k];
			let add_more = conf?.[0]?.['add_more'];
			if(conf && Array.isArray(data[k] ?? null)){
				(data[k] || []).map((row, index) => {
					Object.keys(row).map(k2 => {
						if(!conf?.[add_more == 'true' ? 0 : index]?.[k2])
							delete data[k]?.[index]?.[k2];
					})
				})
			}else if(conf){
				Object.keys(data[k]).map(k2 => {
					if(!conf?.[k2])
						delete data[k]?.[k2];
				})
			}else{
				data[k]=null;
			}
		})
		return data;
	}

	return (
		<PortfolioContainer>
			{getLoading ? (
				<div className='col-sm-12 mt-5 pt-5'>
					<div className='Tableloader mt-5'></div>
				</div>
			) : (
				<div className='additional-info-block'>
					<form onSubmit={saveAdditionalInformation}>
						{getAddInfoArray(addInfoConfig || []).map(
							({ title, type, id, add_more, ...rest }) => (
								<Section
									key={id}
									title={title}
									id={id}
									errors={errors}
									setErrors={setErrors}
									body={body}
									leadId={leadId}
									setBody={setBody}
									type={type}
									parameters={rest}
									orgConfig={addInfoConfig[id] ?? {}}
									edit={
										isAdditionalInfoRequired &&
										state.userType === 'admin' &&
										showAdditionalInfo !== 0
									}
									showAddMore={add_more || false}
									selectedLender={selectedLender}
								/>
							)
						)}

						{state.userType === 'admin' &&
							showAdditionalInfo !== 0 &&
							!getError &&
							!getLoading && (
								<div className='mt-4 d-flex'>
									{checkHasPermission('save-additional-info') && <button
										disabled={loading}
										type='submit'
										className='btn btn-custom mr-1'
									>
										{loading ? (
											<div className='loader' />
										) : cl_lead_lender_status === 2 ||
											cl_lead_lender_status === 3 ? (
											'Save Additional Info'
										) : (
											'Save Additional Info'
										)}
									</button>}
								</div>
							)}
						{getError && (
							<p className='text-center error-text'>
								Failed to load Additional Information
							</p>
						)}
						{getLoading && (
							<div className='d-flex w-100 justify-content-center'>
								<div className='loader' />
							</div>
						)}
					</form>
				</div>
			)}
		</PortfolioContainer>
	);
};

export default AdditionalInformation;
